import React from 'react';
import { Route } from 'react-router-dom';
import FlowRoutes from './Flow/routes';
const routes = () => [<FlowRoutes key="FlowRoutes" />];

const FlowRoute = () => <Route component={routes} />;

export default FlowRoute;



// WEBPACK FOOTER //
// src/modules/screens/flow/routes.js